import {Modal} from 'antd'
import axios from 'axios'
import env from '@/config/env'
import {allRequestAddJxsxx, responseError} from "@/utils/request";

const http = axios.create({
    baseURL: env.EXCEL_URL,
    // credentials: 'include',
    withCredentials: true,
})

http.interceptors.request.use(allRequestAddJxsxx)
http.interceptors.response.use((response) => {
    if (response.data && response.data.status === 'succeed') {
        response.data.status = true
    } else if (response.data && response.data.status === 'failed') {
        response.data.status = false
    }
    if (!(response.config as any).uncheck && !response.data.success) {
        Modal.warning({
            title: '提示',
            content: response.data.message || '处理异常，请稍后再试'
        })
    }
    return response.data
}, responseError)

const request = (url: string, params = {}) => {
    return http(url, params) as any
}

export default request
